import * as moment from "moment";
import NotificationBase from "../NotificationBase";
import {InvoicePaidNotificationDataApiDto, NotificationBaseApiDto} from "../../../api/model/rest";

/**
 * Invoice paid notification class.
 */
export default class InvoicePaidNotification extends NotificationBase {
	/**
	 * @param {string} id notification id.
	 * @param {moment.Moment} visibleFrom Notification datetime.
	 * @param {boolean} read flag if notification is marked as read.
	 * @param {string} type in this case always 'INVOICE_PAID'.
	 * @param {InvoicePaidNotificationData} data invoice paid notification data object.
	 */
	constructor(readonly id: string,
		readonly visibleFrom: moment.Moment,
		readonly read: boolean,
		readonly type: string,
		readonly data: InvoicePaidNotificationData) {
		super(id, visibleFrom, read, type);
	}

	static fromJson(json: NotificationBaseApiDto): InvoicePaidNotification {
		return new InvoicePaidNotification(json.id, moment(json.visibleFrom), json.read, json.type,
			InvoicePaidNotificationData.fromJson(json.data as InvoicePaidNotificationDataApiDto));
	}

	copy({id = this.id, dateTime = this.visibleFrom, read = this.read, type = this.type, data = this.data}) {
		return new InvoicePaidNotification(id, dateTime, read, type, data);
	}
}

/**
 * Invoice paid notification class data.
 */
export class InvoicePaidNotificationData {
	constructor(readonly jobRefNumber: string, readonly invoiceId: string) {}

	static fromJson(json: InvoicePaidNotificationDataApiDto): InvoicePaidNotificationData {
		return new InvoicePaidNotificationData(json.jobRefNumber, json.invoiceId)
	}
}
